import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schedule-panel"
export default class extends Controller {
  static targets = ["panel"]

  toggle() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.toggle("hidden")
  }
}


